import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import * as PatientSessionActions from "../../state/redux/patientSession";
import { deepCopyObject } from "../../utils/helpers";
import AssessmentWizardDialog from "../dialogs/assessmentWizardDialog";
import UserDialog from "../dialogs/userDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import PatientListItem from "../ui/patientListItem";
import Widget from "../ui/widget";
import WidgetContent from "../ui/widgetContent";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const ProviderPatients = props => {
  const { providerPatients, proxyPatientODM, userODM, awsGroup } = props;

  const theme = useTheme();

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);
  const [showSubjectAssessmentDialog, setShowSubjectAssessmentDialog] = useState(null);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (providerPatients != null) {
      setTitleText(
        `${Object.entries(providerPatients).length} Candidate${
          providerPatients.length === 1 ? "" : "s"
        }`,
      );
    } else setTitleText("");
  }, [providerPatients]);

  const getWidgetContent = () => {
    if (providerPatients != null && providerPatients.length > 0) {
      return (
        <WidgetList>
          {providerPatients
            .sort((a, b) => a.omniData.familyName.localeCompare(b.omniData.familyName))
            .map((aPatientODM, index) => {
              return (
                <PatientListItem
                  key={`patientListItem-${aPatientODM._id}`}
                  patientODM={aPatientODM}
                  proxyPatientODM={proxyPatientODM}
                  onClickHandler={() => {
                    setSelectedPatient(aPatientODM);
                  }}
                  onAssessHandler={() => {
                    setShowSubjectAssessmentDialog(aPatientODM);
                  }}
                />
              );
            })}
        </WidgetList>
      );
    } else {
      return (
        <WidgetContent>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignContent="space-evenly"
            sx={{ height: "100%", color: theme.palette.commonground.contrastText }}
          >
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              sx={{ height: "56px", marginBottom: theme.spacing(1) }}
            >
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Typography variant="overline" sx={{ lineHeight: 2, height: "56px" }}>
                  You have not added any candidates yet.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </WidgetContent>
      );
    }
  };

  return (
    <Widget>
      <WidgetTitle title={"Your Applicants"} text={titleText} loading={providerPatients == null}>
        <OmniResponsiveButton
          tooltipTitle="Add a new trial candidate"
          buttonText="Candidate"
          onClick={() => {
            setShowAssessmentDialog(constants.assessmentIDs.omniHealthHistory);
          }}
        />
      </WidgetTitle>

      {providerPatients == null && <WidgetSkeleton />}
      {providerPatients != null && getWidgetContent()}

      {selectedPatient && (
        <UserDialog
          open={selectedPatient != null}
          dialogTitle={`${selectedPatient._id == null ? "Add" : "Edit"} Candidate`}
          omniODM={deepCopyObject(selectedPatient)}
          providerId={awsGroup === constants.userGroups.Provider ? userODM._id : null}
          onDelete={patient => {
            props.deletePatientRequest(patient._id);
            setSelectedPatient(null);
          }}
          onAccept={patient => {
            props.updatePatientRequest(patient);
            setSelectedPatient(null);
          }}
          onClose={() => {
            setSelectedPatient(null);
          }}
        />
      )}
      {showAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showAssessmentDialog != null}
          // lockAssessmentOmniType={showAssessmentDialog}
          // autoStartAssessment={true}
          onClose={() => {
            setShowAssessmentDialog(null);
          }}
        />
      )}
      {showSubjectAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showSubjectAssessmentDialog != null}
          lockSubjectODM={showSubjectAssessmentDialog}
          autoStartAssessment={true}
          onClose={() => {
            setShowSubjectAssessmentDialog(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
  providerPatients: state.providerSession.providerPatients,
  proxyPatientODM: state.userSession.proxyPatientODM,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  updatePatientRequest: PatientSessionActions.updatePatientRequest,
  deletePatientRequest: PatientSessionActions.deletePatientRequest,

  loadPatientODMRequest: PatientSessionActions.loadPatientODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProviderPatients));
